import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AboutDialogComponent } from '../components/shared/about-dialog/about-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AboutDialogService {
  private readonly dialog = inject(MatDialog);

  /**
   * Opens the About dialog (app/server version + environment + browser, with a Copy button).
   */
  open(): void {
    this.dialog.open(AboutDialogComponent, {
      width: '420px',
      autoFocus: false
    });
  }
}
